export const TENIT_PRIMARY_COLOR = "#ad3cc4"// "#e64889";
export const TENIT_SECONDARY_COLOR = "#e64889";